"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@mui/material/SnackbarContent"));
var _colors = require("@mui/material/colors");
var _styles = require("@mui/material/styles");
var _CheckCircle = _interopRequireDefault(require("@mui/icons-material/CheckCircle"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Error = _interopRequireDefault(require("@mui/icons-material/Error"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _Warning = _interopRequireDefault(require("@mui/icons-material/Warning"));
var _Slide = _interopRequireDefault(require("@mui/material/Slide"));
var _coreInfoBarActions = require("../../reducers/coreInfoBarActions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const variantIcon = {
  [_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS]: _CheckCircle.default,
  [_coreInfoBarActions.INFOBAR_VARIANT.WARNING]: _Warning.default,
  [_coreInfoBarActions.INFOBAR_VARIANT.ERROR]: _Error.default,
  [_coreInfoBarActions.INFOBAR_VARIANT.INFO]: _Info.default
};
const StyledSnackbar = (0, _styles.styled)(_Snackbar.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    '&.MuiSnackbar-root': {
      bottom: 0
    },
    '&.MuiSnackbar-anchorOriginBottomCenter': {
      bottom: 0
    },
    '&.MuiSnackbar-anchorOriginBottomLeft': {
      bottom: 0
    },
    '&.MuiSnackbar-anchorOriginBottomRight': {
      bottom: 0
    }
  };
});
const StyledSnackbarContent = (0, _styles.styled)(_SnackbarContent.default, {
  shouldForwardProp: prop => prop !== 'variant'
})(_ref2 => {
  let {
    theme,
    variant
  } = _ref2;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    flexWrap: 'nowrap'
  }, variant === _coreInfoBarActions.INFOBAR_VARIANT.SUCCESS && {
    backgroundColor: _colors.green[600]
  }), variant === _coreInfoBarActions.INFOBAR_VARIANT.ERROR && {
    backgroundColor: theme.palette.error.dark
  }), variant === _coreInfoBarActions.INFOBAR_VARIANT.INFO && {
    backgroundColor: _colors.blue[700]
  }), variant === _coreInfoBarActions.INFOBAR_VARIANT.WARNING && {
    backgroundColor: _colors.amber[700]
  });
});
const Message = (0, _styles.styled)('span')(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre-wrap'
  };
});

/**
 * インフォメーションバー定義
 *
 * @param {any} props
 * @returns インフォメーションバー
 */
const InfoBarContent = /*#__PURE__*/_react.default.forwardRef(function InfoBarContent(props, ref) {
  const {
    variant,
    message,
    onClose
  } = props;
  const Icon = variantIcon[variant];
  return /*#__PURE__*/_react.default.createElement(StyledSnackbarContent, {
    ref: ref,
    variant: variant,
    "aria-describedby": "client-snackbar",
    message: /*#__PURE__*/_react.default.createElement(Message, {
      id: "client-snackbar"
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      sx: {
        fontSize: theme => theme.typography.fontSize * 1.6,
        opacity: 0.9,
        mr: 1
      }
    }), message),
    action: [/*#__PURE__*/_react.default.createElement(_IconButton.default, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement(_Close.default, {
      sx: {
        fontSize: theme => theme.typography.fontSize * 1.6
      }
    }))]
  });
});

/**
 * インフォバー
 * @prop {string} variant - 種別['success', 'warning', 'error', 'info']
 * @prop {string}  message - メッセージ
 * @prop {bool} open -開閉状態
 * @prop {func} onClose - クローズ処理
 */
class InfoBar extends _react.Component {
  render() {
    const {
      variant,
      message,
      open,
      onClose
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(StyledSnackbar, {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      open: open,
      autoHideDuration: 3000,
      onClose: onClose,
      TransitionComponent: _Slide.default,
      TransitionProps: {
        direction: 'up'
      }
    }, /*#__PURE__*/_react.default.createElement(InfoBarContent, {
      variant: variant,
      message: message,
      onClose: onClose
    }));
  }
}
InfoBar.propTypes = {
  variant: _propTypes.default.oneOf(['success', 'warning', 'error', 'info']).isRequired,
  message: _propTypes.default.string.isRequired,
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired
};
InfoBar.defaultProps = {
  variant: 'success',
  message: 'メッセージ'
};
var _default = exports.default = InfoBar;